// extracted by mini-css-extract-plugin
module.exports = {"value":"Temperature_value__21ZMc","metric":"Temperature_metric__33eBm","small":"Temperature_small__1cwZB","big":"Temperature_big__3-1-c"};